import axios from "axios";
var stmarieApi = {
  async ctb(filial) {
    var url = `${process.env.VUE_APP_STRAPI_URL}/api/stmarie/ctb_006`;
    var body = JSON.stringify({
      filial,
    });

    var res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
        "Content-Type": "application/json",
      },
      body,
    })
      .then((res) => {
        if (window.debug) console.log(res);
        return res.json();
      })
      .then((json) => {
        if (window.debug) console.log(json);
        return json;
      })
      .catch((error) => {
        if (window.debug) console.log("Error - Backend: ", error);
        return error;
      });

    return res;
  },

  async ctbV2(filial, anomes, lastDay) {
    var url = `${process.env.VUE_APP_STRAPI_URL}/api/stmarie/ctb_006_v2`;
    var body = JSON.stringify({
      filial,
      anomes,
      lastDay,
    });

    var res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
        "Content-Type": "application/json",
      },
      body,
    })
      .then((res) => {
        if (window.debug) console.log(res);
        return res.json();
      })
      .then((json) => {
        if (window.debug) console.log(json);
        return json;
      })
      .catch((error) => {
        if (window.debug) console.log("Error - Backend: ", error);
        return error;
      });

    return res;
  },

  async ctb006_folha(filial, anomes, dataLote) {
    var url = `${process.env.VUE_APP_STRAPI_URL}/api/stmarie/ctb006_folha`;
    var body = JSON.stringify({
      filial,
      anomes,
      dataLote,
    });
    try {
      let ans = await axios.post(
        url,

        body,

        {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
      return ans;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        const { status, statusText, data } = error.response;
        if (data?.errors)
          throw new Error(data?.errors.map((el) => el.message)?.join(",")); // Rethrow or handle the error
        if (data?.error) throw new Error(data?.error.message); // Rethrow or handle the error
        if (data?.detail) {
          if (Array.isArray(data?.detail))
            throw new Error(
              data?.detail?.map((el) => JSON.stringify(el))?.join("\n")
            ); // Rethrow or handle the error
          throw new Error(data?.detail); // Rethrow or handle the error
        }
      } else if (error.request) {
        throw new Error("No response from the server.");
      } else {
        throw new Error("An error occurred while setting up the request.");
      }
    }
  },

  async ctb006_despesa(filCod, pesCod, dataInicio, dataFim, dataLote, dataLote2) {
    var url = `${process.env.VUE_APP_STRAPI_URL}/api/stmarie/ctb006_despesa`;
    var body = JSON.stringify({
      filCod,
      pesCod,
      dataInicio, 
      dataFim,
      dataLote,
      dataLote2
    });
    try {
      let ans = await axios.post(
        url,

        body,

        {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
      return ans;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        const { status, statusText, data } = error.response;
        if (data?.errors)
          throw new Error(data?.errors.map((el) => el.message)?.join(",")); // Rethrow or handle the error
        if (data?.error) throw new Error(data?.error.message); // Rethrow or handle the error
        if (data?.detail) {
          if (Array.isArray(data?.detail))
            throw new Error(
              data?.detail?.map((el) => JSON.stringify(el))?.join("\n")
            ); // Rethrow or handle the error
          throw new Error(data?.detail); // Rethrow or handle the error
        }
      } else if (error.request) {
        throw new Error("No response from the server.");
      } else {
        throw new Error("An error occurred while setting up the request.");
      }
    }
  },
  async rp_fin417(filCod, priCod) {
    var url = `https://backend.stmarie.com.br/api/stmarie/rp_fin417`;
    var body = JSON.stringify({
      filCod,
      priCod,
    });

    try {
      var res = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
          "Content-Type": "application/json",
        },
        body,
      })
        .then((res) => {
          if (window.debug) console.log(res);
          return res.json();
        })
        .then((json) => {
          if (window.debug) console.log(json);
          return json;
        })
        .catch((error) => {
          if (window.debug) console.log("Error - Backend: ", error);
          return error;
        });

      return res;
    } catch (error) {
      if (error.response) {
        const { status, statusText, data } = error.response;
        if (data?.errors)
          throw new Error(data?.errors.map((el) => el.message)?.join(",")); // Rethrow or handle the error
        if (data?.error) throw new Error(data?.error.message); // Rethrow or handle the error
      } else if (error.request) {
        throw new Error("No response from the server.");
      } else {
        throw new Error("An error occurred while setting up the request.");
      }
    }
  },
};

export default stmarieApi;
